import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import Routes from './routes/routes';
import TagManager from 'react-gtm-module';

const browserHistory = createBrowserHistory();
ReactGA.initialize(process.env.REACT_APP_GOOGLE_TRACKING_ID, { testMode: process.env.NODE_ENV === 'test' });

browserHistory.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TRACKING_TAG_MANAGER_ID
}
TagManager.initialize(tagManagerArgs)

export default class App extends Component {

  componentDidMount() {
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Router history={browserHistory}>
              <Routes />
            </Router>
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}
